module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['dropdown account-info', {
      'white-theme': _vm.specialHeader
    }]
  }, [_c('a', {
    staticClass: "nickname",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.nickName))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "id": "account-ul",
      "aria-labelledby": "dLabel"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v(_vm._s(_vm.$t("myAccount")))])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v(_vm._s(_vm.$t("signOut")))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c5073ad!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plexHeader/mainHeader/accountInfo/AccountInfo.vue
// module id = 1273
// module chunks = 1